import { ACTION_TYPES } from '../../utils/Constants';

const VisitInformationReducer = (
    state = {
        VisitInformation: {},
    },
    action = {}
) => {
    switch (action.type) {
        case ACTION_TYPES.PATIENT.GET_VISIT_INFORMATION:
            state = {
                ...state,
                VisitInformation: action.payload,
            };
            break;
        default:
            break;
    }
    return state;
};
export default VisitInformationReducer;
